(function () {
	// globals
	window.EWO.Events = {};
	let eventsList = [];
	EWO.MD({
		global: EWO.Events,
		name: 'events',
		containerClass: 'js-events',
		listTemplate: '/app/events/templates/events.ejs',
		createOrEditTemplate: '/app/events/templates/eventsCreateOrEdit.ejs',
		// createOrEditValidationRules: {
		// 	rules: {
		// 		eventTypeId: 'required',
		// 		descDe: 'required',
		// 		descIt: 'required',
		// 		statusId: 'required',
		// 		electionDate: 'required date',
		// 		runoffDate: 'required date'
		// 	}
		// },
		createOrEditAdditionalData: function (id) {

		},
		createOrEditCallback: function (id) {

		},
		listAdditionalData: function (filter) {
			const { electionId } = filter;
			return $.get(EWO.config.apiUrlPrefix + '/ElectionEvents/eventtypes')
				.then(eventTypes => {
					return {
						eventTypes, // Dati effettivi ottenuti dalla richiesta
						electionId
					};
				})
				.catch(error => {
					console.error('Errore nel recupero dei tipi di evento:', error);
					return {
						eventTypes: [], // Ritorna un array vuoto in caso di errore
						electionId
					};
				});
		},
		beforeSaveCallback: function (data) {

		},
		listCallback: function (data) {


			const tbody = document.querySelector('#draggableTable tbody');
			let draggingElement = null;
			// Aggiunge gli event listener a tutte le righe
			function addDragEvents(row) {
				row.addEventListener('dragstart', handleDragStart);
				row.addEventListener('dragend', handleDragEnd);
				row.addEventListener('dragover', handleDragOver);
				row.addEventListener('drop', handleDrop);
				row.addEventListener('dragenter', handleDragEnter);
				row.addEventListener('dragleave', handleDragLeave);
			}

			// Aggiunge gli event listener alle righe esistenti
			document.querySelectorAll('#draggableTable tbody tr').forEach(row => {
				addDragEvents(row);
			});

			function handleDragStart(e) {
				draggingElement = this;
				this.classList.add('dragging');
				e.dataTransfer.effectAllowed = 'move';
			}

			function handleDragEnd(e) {
				this.classList.remove('dragging');
				document.querySelectorAll('.drag-over').forEach(row => {
					row.classList.remove('drag-over');
				});
				draggingElement = null;
			}

			function handleDragOver(e) {
				e.preventDefault();
				e.dataTransfer.dropEffect = 'move';
			}

			function handleDragEnter(e) {
				this.classList.add('drag-over');
			}

			function handleDragLeave(e) {
				this.classList.remove('drag-over');
			}

			function handleDrop(e) {
				e.preventDefault();
				if (draggingElement && this !== draggingElement) {
					let allRows = [...tbody.querySelectorAll('tr')];
					let draggingPos = allRows.indexOf(draggingElement);
					let dropPos = allRows.indexOf(this);

					if (draggingPos < dropPos) {
						this.parentNode.insertBefore(draggingElement, this.nextSibling);
					} else {
						this.parentNode.insertBefore(draggingElement, this);
					}
					// Ottiene tutte le righe della tabella dopo il riordinamento
					let rows = tbody.querySelectorAll('tr');

					// Estrae e stampa i valori della seconda colonna (priority)
					console.log("Nuovo ordine delle priorità:");
					rows.forEach(row => {
						let id = row.getAttribute('data-manage-id');
						console.log(id);
					});

					// alert('Riga spostata con successo!');
				}
				this.classList.remove('drag-over');
			}
		},
		apiRoot: EWO.config.apiUrlPrefix + '/ElectionEvents/configuration',
		routingRoot: '/events/:electionId',
		apiRootForUpdate: EWO.config.apiUrlPrefix + '/ElectionEvents/configuration',

		datatablesOptions: { 'paging': false, 'lengthChange': false, 'info': false }



	});

	$(document).on('submit', '#eventsForm', function (event) {
		event.preventDefault();
		const listEventsToSave = getEventsFromForm();
		const electionId = window.location.pathname.split('/').filter(Boolean).pop();
		saveEvents(listEventsToSave, electionId);

	});
	const getEventsFromForm = () => {
		eventsListOriginal = Array.from(document.querySelectorAll('#draggableTable tbody tr')).map(row => JSON.parse(row.getAttribute('data-row-data')));
		if (!eventsListOriginal[0]) {
			eventsListOriginal = [];
		}

		const formData = new FormData(document.getElementById('eventsForm'));
		const updatedEvents = [];

		for (let i = 0; i < document.getElementById('eventsForm').elements.length; i++) {
			const element = document.getElementById('eventsForm').elements[i];
			const id = Number(element.name.split('_')[1]);
			let event = updatedEvents.find(e => e.id === id);
			if (!event) {
				event = { id: Number(id) };
				updatedEvents.push(event);
			}
			if (element.name.startsWith('eventTypeId')) {
				event.eventTypeId = Number(element.value);
			} else if (element.name.startsWith('startDate')) {
				event.startDate = new Date(element.value);
			} else if (element.name.startsWith('endDate')) {
				event.endDate = new Date(element.value);
			} else if (element.name.startsWith('param')) {
				event.param = element.value;
			} else if (element.name.startsWith('turn')) {
				event.turn = Number(element.value);
			}
		}

		eventsListOriginal = eventsListOriginal.map(originalEvent => {
			const updatedEvent = updatedEvents.find(e => e.id === originalEvent.id);
			return updatedEvent ? { ...originalEvent, ...updatedEvent } : originalEvent;
		});

		return eventsListOriginal;
	};
	const saveEvents = (listEventsToSave, electionId) => {
		const eventsListToSave = listEventsToSave.map((event, index) => {
			return {
				...event,
				priority: index + 1
			}
		});
		$.ajax({
			url: EWO.config.apiUrlPrefix + '/ElectionEvents/configuration/' + electionId,
			type: 'POST',
			contentType: 'application/json',
			data: JSON.stringify(eventsListToSave),
			success: function (response) {
				const urlParams = new URLSearchParams(window.location.search);
				if(urlParams.get("returnUrl") != null){
					window.location.href = urlParams.get("returnUrl");
				}
				else
				{
					window.location.reload();
				}
			},
			error: function (error) {
				console.error('Error:', error);
			}
		});
	}

	$(document).on('submit', '#newEventForm', function (event) {
		event.preventDefault();
		console.log('due')
		eventsListOriginal = getEventsFromForm();
		// if(!eventsListOriginal?.[0] ) {
		// 	eventsListOriginal = [];
		// }
		const eventEmpty = {
			"id": null,
			"electionId": null,
			"eventTypeId": null,
			"status": null,
			"date": null,
			"startDate": null,
			"endDate": null,
			"priority": null,
			"desc": null,
			"param": null,
			"turn": null
		}

		const formData = new FormData(event.target);
		const data = Object.fromEntries(formData);
		// Pulisco i dati del form
		const eventToAdd = JSON.parse(JSON.stringify({ ...eventEmpty, ...data }));
		if (eventToAdd.startDate) {
			eventToAdd.startDate = new Date(eventToAdd.startDate);
		}
		if (eventToAdd.endDate) {
			eventToAdd.endDate = new Date(eventToAdd.endDate);
		}
		eventToAdd.electionId = Number(eventToAdd.electionId);
		eventToAdd.eventTypeId = Number(eventToAdd.eventTypeId);
		eventToAdd.priority = Number(eventToAdd.priority);


		const { electionId } = eventToAdd;
		eventsListOriginal.push(eventToAdd);

		saveEvents(eventsListOriginal, electionId);

	});
	$(document).on('click', '.js-events .js-deleteEvent', function (ev) {
		var el = $(ev.currentTarget);
		ev.preventDefault();

		var id = el.attr('data-id');

		$.ajax({
			type: 'DELETE',
			url: '/api/v1/ElectionEvents/configuration' + '/' + id
		})
			.done(function () {
				el.parents('tr').remove();
				var undoNotice = i18next.t('Entry deleted.');
				var notification = PNotify.success({
					text: undoNotice,
					textTrusted: true,
					addClass: '.js-events .js-undo-' + id
				});
				$('.js-events .js-undo-' + id).data('pnotify', notification);
			});
	});
})();
